var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var User = function (_a) {
    var onClick = _a.onClick, className = _a.className;
    return (_jsxs("svg", __assign({ width: '36', height: '36', viewBox: '0 0 36 36', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', onClick: onClick, className: className }, { children: [_jsx("circle", { opacity: '0.05', cx: '18', cy: '18', r: '18', fill: '#17181B' }), _jsx("path", { d: 'M18 17.25C19.7949 17.25 21.25 15.7949 21.25 14C21.25 12.2051 19.7949 10.75 18 10.75C16.2051 10.75 14.75 12.2051 14.75 14C14.75 15.7949 16.2051 17.25 18 17.25Z', stroke: '#17181B', strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }), _jsx("path", { d: 'M12.8477 25.25H23.1527C24.2946 25.25 25.1742 24.2681 24.641 23.2584C23.8565 21.7731 22.0682 20 18.0002 20C13.9322 20 12.1439 21.7731 11.3595 23.2584C10.8262 24.2681 11.7058 25.25 12.8477 25.25Z', stroke: '#17181B', strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' })] })));
};
export { User };
//# sourceMappingURL=User.js.map